import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const DateIn = () => {
  const date_in = useInputStore(state => state.date_in)
  const setValue = useInputStore((state) => state.set_value)

  const handleChange = (event) => {
    console.log(event.target.value)
      setValue({ 'date_in':event.target.value})
  }
  
  // validation
  const isValidDate = useCallback(() => {
    const date = new Date(date_in)

    // is it a valid date
    return !isNaN(date)
  }, [date_in])

  useStepValidator(INPUT_STEP_NAMES.housing, 'date_in', () => isValidDate(date_in))
  
  return (
    <Tooltip title='Day cows were brought in'>
      <TextField
        size='small'
        label='Date In'
        type='date'
        InputLabelProps={{
          shrink: true,
        }}
        value={date_in}
        onChange={handleChange}
        error={!isValidDate()}
        helperText={!isValidDate() ? 'Please select a valid date' : ''}
      />
    </Tooltip>
  )
}
